export class UpperCaseValueConverter {
    toView(value) {
        return !!value ? value.toUpperCase() : '';
    }

    fromView(value) {
        return value;
    }
}
